import React, { useEffect, useState } from 'react';
import { Loader2, Scissors } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Input } from '../../../ui/input';
import { Label } from '../../../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '../../../ui/dialog';
import { ColorImage } from '../ColorImage';
import { tierLabels } from '../../../../lib/fabricLabels';

// Undo a wrong merge: move the ticked colors into a brand-new material.
export const SplitMaterialDialog = ({ open, onOpenChange, material, colors, onSplit, saving, brandName }) => {
  const L = tierLabels(brandName);
  const [name, setName] = useState('');
  const aliases = material?.aliases || [];

  useEffect(() => { if (open) setName(''); }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="split-material-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Scissors className="w-4 h-4" /> Split {colors.length} color{colors.length === 1 ? '' : 's'} out of “{material?.name}”</DialogTitle>
          <DialogDescription>
            The selected colors move into a new {L.tier3.toLowerCase()} right next to this one. Prices, catalog link and specs are copied over.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="flex flex-wrap gap-1.5">
            {colors.map((c) => (
              <span key={c.id} className="inline-flex items-center gap-1.5 rounded-full border border-neutral-200 bg-neutral-50 pl-1 pr-2.5 py-0.5 text-xs" data-testid={`split-color-${c.id}`}>
                <span className="w-5 h-5 rounded-full overflow-hidden border border-neutral-200">
                  {c.image_url ? <ColorImage src={c.image_url} alt="" w={128} className="w-full h-full" /> : <span className="block w-full h-full" style={{ backgroundColor: c.hex_color || '#e5e5e5' }} />}
                </span>
                {c.name}{c.code ? <span className="text-neutral-400">{c.code}</span> : null}
              </span>
            ))}
          </div>
          <div>
            <Label>New {L.tier3} name *</Label>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder={aliases[0] ? `e.g., ${aliases[0]}` : 'e.g., Osaka'} className="mt-1" data-testid="split-target-name-input" />
            {aliases.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-1">
                <span className="text-[10px] text-neutral-500 self-center">Former names:</span>
                {aliases.map((a) => (
                  <button key={a} type="button" onClick={() => setName(a)} className="text-[10px] px-2 py-0.5 rounded-full border border-neutral-200 hover:border-amber-400 hover:text-amber-700" data-testid={`split-alias-${a}`}>{a}</button>
                ))}
              </div>
            )}
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={() => onSplit(name.trim())} disabled={saving || !name.trim()} className="bg-amber-600 hover:bg-amber-700 gap-2" data-testid="split-confirm-btn">
            {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Scissors className="w-4 h-4" />} Split
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SplitMaterialDialog;
